(function() {
    "use strict";

    angular.module("eSign")
    .controller("ChooseDocumentController", ['$scope', '$http', '$window', 'signTaskService', 'sessionService', 'appConfig', function($scope, $http, $window, signTaskService, sessionService, appConfig) {

        $scope.signTaskDocuments = [];
        $scope.ExternalReference = "";
        $scope.ExternalReferenceName = "";
        $scope.isLoading = true;
        $scope.enableDocumentUpload = false;

        $scope.init = function (value) {
            //This function is sort of private constructor for controller
            $scope.enableDocumentUpload = value;
        };

        var getNextStep = function (signtask) {
            var url = appConfig.signCompletedUrl;
            if ($scope.enableDocumentUpload) url = appConfig.uploadDocumentationUrl;
            if (signtask == null) return url;

            switch (signtask.nextStep) {
                case "upload":
                    url = appConfig.uploadDocumentationUrl;
                    break;
                case "insurance":
                    url = appConfig.insuranceUrl;
                    break;
                case "confirmation":
                    url = appConfig.signCompletedUrl;
                    break;
                default:
            }

            return url;
        };

        // Methods for proceeding and going back
        $scope.continue = function () {
            $window.location.href = getNextStep();
        };
        $scope.goBack = function() {
          $window.location.href = appConfig.chooseSignTaskUrl;
        };

        var setCurrentDocReferenceAndOpenIframe = function (reference) {
            angular.element(document.querySelector(".page")).addClass("page-iframe");
            sessionService.setCurrentDocumentReference(reference).then(function (response) {
                sessionService.getSettings().then(function (response) {
                    if (response.data.countryCode === "FI") {
                        $window.location.href = appConfig.iframeSignUrl;
                    } else {
                        $scope.iframeUrl = appConfig.iframeSignUrl;
                        $scope.displayIframe = true;
                        $scope.isLoading = false;
                    }
                });
            });
        }

        // Checking if the user have opened every document. The isOpened stat is good both for signable and not signable documents.
        // For documents required signing the isOpened bool will be toggled when its signed.
        var checkIfAllDocumentsAreHandled = function(signtask) {
			return signtask.documents.length > 0 && signtask.documents.filter(function (obj) { return !obj.isOpened; }).length == 0;
        };

        var documentsForSigningOnly = function (signtask) {
			return signtask.documents.length > 0 && signtask.documents.filter(function (obj) { return !obj.requiresSigning; }).length == 0;
        };

        // Async fetching the documents from the server, and afterwards checking their state.
        var getDocumentsFromDocHub = function() {
            signTaskService.getDocumentsForSignTask().then(function (response) {
				
				if (response.data.notReadyToSign) {
					$window.location.href = appConfig.chooseSignTaskUrl;
				}
                if (checkIfAllDocumentsAreHandled(response.data)) {
                    $window.location.href = getNextStep(response.data);
				} else if (documentsForSigningOnly(response.data) && response.data.supportsDocumentsListing) {
                    setCurrentDocReferenceAndOpenIframe(response.data.documents[0].reference);
                } else {
                    $scope.signTaskDocuments = response.data.documents;
                    $scope.isLoading = false;
                }
            });
        };

        // If a document is required to sign, switch to the sign iframe, otherwise just show the document
		$scope.openDocumentForAction = function (document) {
            if (document.isSigned || !document.requiresSigning) {
                // TODO: This may have a bug, running the getDocumentsFromDocHub twice. Workaroud may be to open in an ifram instead
				var doc = $window.open(signTaskService.getSignedDocumentURL(document.reference), '_blank');
                doc.onload = function () {
                    getDocumentsFromDocHub();
                };
            }
            else {
                setCurrentDocReferenceAndOpenIframe(document.reference);
            }
        };

        var getExternalReference = function () {
            signTaskService.getExternalReference().then(function (response) {
                $scope.ExternalReference = response.data;
                $scope.ExternalReferenceName = ($scope.ExternalReference.indexOf('_') < 0) ? $scope.ExternalReference : $scope.ExternalReference.substr(0, $scope.ExternalReference.indexOf('_'));
                getDocumentsFromDocHub();
            });
        };

        // Start of the page by fetching
        getExternalReference();
        
    }]);
}());
